module.exports = __webpack_public_path__ + "img/pin-node-1000.f0e2599c.png";